function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.07 13.61c-.822-.115-2.74.284-5.207-1.37C10.96 7.62 1.04 10.872.875 15.434c0 .57 0 1.198.11 1.825.164 1.255 1.15 2.167 2.356 2.224h.548c-.384-2.11 1.301-4.233 3.712-4.233 2.357 0 4.015 2.123 3.577 4.233h5.672c-.209-2.224 1.482-4.233 3.784-4.233 2.301 0 4.024 2.01 3.783 4.233.877-.114 2.653-.456 2.708-2.224 0-1.654-1.534-3.479-4.055-3.65zm-17.208-.4H3.286c.767-.685 1.754-1.198 2.576-1.426v1.426zm1.096 0v-1.654c1.26-.228 2.356-.342 3.343-.342l.164 1.996H6.958zm4.549 0-.165-1.996c2.74.114 4.22.798 5.973 1.996h-5.809z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.624 16.125c-1.62 0-2.933 1.366-2.933 3.052 0 1.685 1.313 3.052 2.933 3.052 1.62 0 2.932-1.367 2.932-3.052 0-1.686-1.313-3.052-2.932-3.052zm0 4.905c-.983 0-1.781-.83-1.781-1.853 0-1.024.798-1.853 1.78-1.853.984 0 1.781.83 1.781 1.853 0 1.024-.797 1.853-1.78 1.853zM7.551 16.146c-1.62 0-2.932 1.367-2.932 3.052 0 1.686 1.313 3.052 2.932 3.052 1.62 0 2.933-1.366 2.933-3.052 0-1.685-1.313-3.052-2.933-3.052zm0 4.906c-.983 0-1.78-.83-1.78-1.854s.797-1.853 1.78-1.853c.984 0 1.781.83 1.781 1.853 0 1.024-.797 1.854-1.78 1.854z"
});

var SvgSuv = function SvgSuv(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suv.3dc142fb.svg";
export { ForwardRef as ReactComponent };